// extracted by mini-css-extract-plugin
export var opportunitiesListItem = "bT_hQ";
export var opportunitiesListItemExcerpt = "bT_hR";
export var opportunitiesListItemFooter = "bT_hS";
export var opportunitiesListItemFooterImages = "bT_hT";